import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-compact-left', 'ChevronCompactLeft', [["path",{"d":"M13 20l-3 -8l3 -8"}]]);